import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { NavController, PopoverController, ModalController, AlertController, ToastController, LoadingController } from 'ionic-angular';
import { ViewContactPage } from '../view-contact/view-contact';
import { EditPopoverPage } from '../edit-popover/edit-popover';
import firebase from 'firebase/app';
import { ChangeAssignedBrokerPage } from '../change-assigned-broker/change-assigned-broker';
import { LoadingProvider } from '../../providers/loading/loading';
import { Http, RequestOptions, Headers } from '@angular/http';
import { StepformPage } from '../stepform/stepform';
import { TentativeRealEstateAssetPage } from '../tentative-real-estate-asset/tentative-real-estate-asset';
import { ChangeLogProfilePage } from '../change-log-profile/change-log-profile';
import { HomeService } from '../../app/services/home-service';
import {EnvDataService} from '../../app/services/env-data-service';
@Component({
  selector: 'page-search',
  templateUrl: 'search.html',
  providers:[EnvDataService]
})
export class SearchPage implements OnInit{

  public usersList: any[];
  public loadedUsersList: any[];
  public contactTotal: number;
  public userRole: any;
  public deleted_access: any;
  public limit: number;
  public allTotalContact: number;
  public contactTtype: number;
  public contactTmore: number;
  public uid: any;
  public haveClickedview: any;
  public haveRecord: any;

  constructor(
    public navCtrl: NavController, 
    private firestore: AngularFirestore,
    public loadingProvider: LoadingProvider,
    public popoverCtrl: PopoverController,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    public http: Http,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
    public HomeService: HomeService,
    public db: AngularFirestore,
    private EnvDataService:EnvDataService
  ) {}
  ngOnInit() {

    this.limit = 20;
    this.allTotalContact = 0;
    this.contactTmore = 1;

    this.userRole = window.localStorage.getItem("userRole");
    this.deleted_access = window.localStorage.getItem("deleted_access");
    let uid = window.localStorage.getItem("uid");
    this.uid = uid;
    if(this.userRole == 'super_admin'){
      if(this.deleted_access == 1){
        this.firestore.collection(`users` , ref => ref.where('created_date','>',0 ).where('roles.contact','==',true ).orderBy('created_date', 'desc').limit(this.limit)).valueChanges().subscribe((usersList:any) => {
          for(let i = 0; i < usersList.length; i++) { 
            usersList[i].user_data = [];
            usersList[i].total_Record = 0;
            usersList[i].icon = 'ios-arrow-down-outline';
            if(usersList[i].reference_broker == "" || usersList[i].reference_broker == null || usersList[i].reference_broker == undefined){}else{
              var docRef1 = firebase.firestore().collection("users").doc(usersList[i].reference_broker);
              docRef1.get().then(function(doc) {
                if (doc.exists) {
                  usersList[i].broker_name = doc.data().firstname+' '+doc.data().lastname;
                } else {
                  console.log("No such document!");
                }
              }).catch(function(error) {
                console.log("Error getting document:", error);
              });
            }
          }
          this.usersList = usersList;
          this.loadedUsersList = usersList;
          this.contactTotal = usersList.length;
        });

        this.firestore.collection(`users` , ref => ref.where('created_date','>',0 ).where('roles.contact','==',true ).orderBy('created_date', 'desc')).valueChanges().subscribe((allUsersList:any) => {
          for(let i = 0; i < allUsersList.length; i++) { 
            allUsersList[i].user_data = [];
            allUsersList[i].total_Record = 0;
            allUsersList[i].icon = 'ios-arrow-down-outline';
            if(allUsersList[i].reference_broker == "" || allUsersList[i].reference_broker == null || allUsersList[i].reference_broker == undefined){}else{
              var docRef1 = firebase.firestore().collection("users").doc(allUsersList[i].reference_broker);
              docRef1.get().then(function(doc) {
                if (doc.exists) {
                  allUsersList[i].broker_name = doc.data().firstname+' '+doc.data().lastname;
                } else {
                  console.log("No such document!");
                }
              }).catch(function(error) {
                console.log("Error getting document:", error);
              });
            }
          }
          this.loadedUsersList = allUsersList;
        });
      }else{
        this.firestore.collection(`users` , ref => ref.where('created_date','>',0 ).where('roles.contact','==',true ).where('deleted','==',0 ).orderBy('created_date', 'desc').limit(this.limit)).valueChanges().subscribe((usersList:any) => {
          for(let i = 0; i < usersList.length; i++) { 
            usersList[i].user_data = [];
            usersList[i].total_Record = 0;
            usersList[i].icon = 'ios-arrow-down-outline';
            if(usersList[i].reference_broker == "" || usersList[i].reference_broker == null || usersList[i].reference_broker == undefined){}else{
              var docRef1 = firebase.firestore().collection("users").doc(usersList[i].reference_broker);
              docRef1.get().then(function(doc) {
                if (doc.exists) {
                  usersList[i].broker_name = doc.data().firstname+' '+doc.data().lastname;
                } else {
                  console.log("No such document!");
                }
              }).catch(function(error) {
                console.log("Error getting document:", error);
              });
            }
          }
          this.usersList = usersList;
          this.loadedUsersList = usersList;
          this.contactTotal = usersList.length;
        });

        this.firestore.collection(`users` , ref => ref.where('created_date','>',0 ).where('roles.contact','==',true ).where('deleted','==',0 ).orderBy('created_date', 'desc')).valueChanges().subscribe((allUsersList:any) => {
          for(let i = 0; i < allUsersList.length; i++) { 
            allUsersList[i].user_data = [];
            allUsersList[i].total_Record = 0;
            allUsersList[i].icon = 'ios-arrow-down-outline';
            if(allUsersList[i].reference_broker == "" || allUsersList[i].reference_broker == null || allUsersList[i].reference_broker == undefined){}else{
              var docRef1 = firebase.firestore().collection("users").doc(allUsersList[i].reference_broker);
              docRef1.get().then(function(doc) {
                if (doc.exists) {
                  allUsersList[i].broker_name = doc.data().firstname+' '+doc.data().lastname;
                } else {
                  console.log("No such document!");
                }
              }).catch(function(error) {
                console.log("Error getting document:", error);
              });
            }
          }
          this.loadedUsersList = allUsersList;
        });
      }
    }else if(this.userRole == 'broker'){
      this.firestore.collection(`users` , ref => ref.where('created_date','>',0 ).where('roles.contact','==',true ).where('deleted','==',0 ).where('reference_broker','==',uid ).orderBy('created_date', 'desc').limit(this.limit)).valueChanges().subscribe(usersList => {
        this.usersList = usersList;
        this.loadedUsersList = usersList;
        this.contactTotal = usersList.length;
        for(let i = 0; i < this.usersList.length; i++) { 
          this.usersList[i].user_data = [];
          this.usersList[i].total_Record = 0;
          this.usersList[i].icon = 'ios-arrow-down-outline';
        }
      });

      this.firestore.collection(`users` , ref => ref.where('created_date','>',0 ).where('roles.contact','==',true ).where('deleted','==',0 ).where('reference_broker','==',uid ).orderBy('created_date', 'desc')).valueChanges().subscribe((allUsersList:any) => {
        for(let i = 0; i < allUsersList.length; i++) { 
          allUsersList[i].user_data = [];
          allUsersList[i].total_Record = 0;
          allUsersList[i].icon = 'ios-arrow-down-outline';
          if(allUsersList[i].reference_broker == "" || allUsersList[i].reference_broker == null || allUsersList[i].reference_broker == undefined){}else{
            var docRef1 = firebase.firestore().collection("users").doc(allUsersList[i].reference_broker);
            docRef1.get().then(function(doc) {
              if (doc.exists) {
                allUsersList[i].broker_name = doc.data().firstname+' '+doc.data().lastname;
              } else {
                console.log("No such document!");
              }
            }).catch(function(error) {
              console.log("Error getting document:", error);
            });
          }
        }
        this.loadedUsersList = allUsersList;
      });
    }else if(this.userRole == 'loan_admin'){
      this.usersList = [];
      this.contactTotal = 0;
      var docRef = firebase.firestore().collection("users").doc(uid);
      let thiss = this;
      docRef.get().then(function(doc) {
        if (doc.exists) {
          let user_data = doc.data();
          for(let j = 0; j < user_data.assigned_broker.length; j++){
            thiss.firestore.collection(`users` , ref => ref.where('created_date','>',0 ).where('roles.contact','==',true ).where('deleted','==',0 ).where('reference_broker','==',user_data.assigned_broker[j] ).orderBy('created_date', 'desc').limit(thiss.limit)).valueChanges().subscribe((usersList:any) => {
              for(let i = 0; i < usersList.length; i++) { 
                usersList[i].user_data = [];
                usersList[i].total_Record = 0;
                usersList[i].icon = 'ios-arrow-down-outline';
                if(usersList[i].reference_broker == "" || usersList[i].reference_broker == null || usersList[i].reference_broker == undefined){}else{
                  var docRef1 = firebase.firestore().collection("users").doc(usersList[i].reference_broker);
                  docRef1.get().then(function(doc) {
                    if (doc.exists) {
                      usersList[i].broker_name = doc.data().firstname+' '+doc.data().lastname;
                    } else {
                      console.log("No such document!");
                    }
                  }).catch(function(error) {
                    console.log("Error getting document:", error);
                  });
                }
              }
              thiss.usersList = thiss.usersList.concat(usersList);
              thiss.loadedUsersList = thiss.usersList.concat(usersList);
              thiss.contactTotal += usersList.length;
            });

            thiss.firestore.collection(`users` , ref => ref.where('created_date','>',0 ).where('roles.contact','==',true ).where('deleted','==',0 ).where('reference_broker','==',user_data.assigned_broker[j] ).orderBy('created_date', 'desc')).valueChanges().subscribe((allUsersList:any) => {
              for(let i = 0; i < allUsersList.length; i++) { 
                allUsersList[i].user_data = [];
                allUsersList[i].total_Record = 0;
                allUsersList[i].icon = 'ios-arrow-down-outline';
                if(allUsersList[i].reference_broker == "" || allUsersList[i].reference_broker == null || allUsersList[i].reference_broker == undefined){}else{
                  var docRef1 = firebase.firestore().collection("users").doc(allUsersList[i].reference_broker);
                  docRef1.get().then(function(doc) {
                    if (doc.exists) {
                      allUsersList[i].broker_name = doc.data().firstname+' '+doc.data().lastname;
                    } else {
                      console.log("No such document!");
                    }
                  }).catch(function(error) {
                    console.log("Error getting document:", error);
                  });
                }
              }
              thiss.loadedUsersList = thiss.loadedUsersList.concat(allUsersList);
            });
          }
        }
      }).catch(function(error) {
        console.log("Error getting document:", error);
      });
    }
  }

  initializeItems(): void {
    this.usersList = this.loadedUsersList;
    console.log('this.usersList', this.usersList)
  }

  searchUser(evt){
    this.initializeItems();      
    const searchTerm = evt.srcElement.value;      
    this.contactTotal = this.usersList.length;
    if (!searchTerm) {
      return;
    } 
    this.usersList = this.loadedUsersList.filter(currentUser => {
      let fullName = currentUser.firstname+' '+currentUser.lastname;
      if ((fullName || currentUser.firstname || currentUser.lastname || currentUser.email || currentUser.mobile_phone) && searchTerm) {
        if (fullName.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1 || currentUser.firstname.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1 || currentUser.lastname.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1 || currentUser.email.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1 || currentUser.mobile_phone.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1) {
          this.contactTmore = 0;
          return true;
        }
        return false;
      }
    });
  }

  viewContact(event, contact_uid, SDF_form_document_id){
    this.navCtrl.push(ViewContactPage,{
      contact_uid:contact_uid,
      SDF_form_document_id:SDF_form_document_id
      });
  }

  restoreContact(event, contact_uid, secondary_contact_uid, main_contact_uid){

    let alert = this.alertCtrl.create({
      title: 'Confirm restore contact',
      message: 'Are you sure you want to delete this restore?',
      buttons: [
          {
              text: 'No',
              handler: () => {
                  console.log('Cancel clicked');
              }
          },
          {
              text: 'Yes',
              handler: () => {
                if(contact_uid !=""){
                  this.loadingProvider.startLoading();
                  var headers = new Headers();
                  headers.append("Accept", 'application/json');
                  headers.append('Content-Type', 'application/json' );
                  const requestOptions = new RequestOptions({ headers: headers });
                  let secondary_contact_uid1 = '';
                  if(secondary_contact_uid != undefined){
                    secondary_contact_uid1 = secondary_contact_uid;
                  }else if(main_contact_uid != undefined){
                    secondary_contact_uid1 = main_contact_uid;
                  }
                  let postData = {
                    'contact_id' : contact_uid,
                    'secondary_contact_uid' : secondary_contact_uid1
                  }
                  var url = this.EnvDataService.EnvData.sendbox_api+"/restoreContact";
                  this.http.post(url, postData, requestOptions)
                  .subscribe(data => {
                    if(data['_body'] == 'success'){
                      this.presentToastSuccess('Restore successfully.');
                      this.loadingProvider.stopLoading();
                    }else{
                      this.presentToastSuccess('Something went wrong please try again later.');
                      this.loadingProvider.stopLoading();
                    }
                  }, error => {
                    this.presentToast(error.message);      
                  });
                }
              }
          }
      ]
    });
    alert.present();    
  }


  deleteContact(event, SDF_form_document_id, document_id, contact_type, uid, index, index1){

    let alert = this.alertCtrl.create({
      title: 'Confirm delete contact',
      message: 'Are you sure you want to delete this contact?',
      buttons: [
          {
              text: 'No',
              handler: () => {
                  console.log('Cancel clicked');
              }
          },
          {
              text: 'Yes',
              handler: () => {
                if(document_id !=""){
                  this.loadingProvider.startLoading();
                  let postData = {
                    'document_id': document_id,
                    'SDF_form_document_id': SDF_form_document_id,
                    'contact_type': contact_type,
                    'contact_uid' : uid,
                    'deleted_date': new Date().getTime()
                  }
                  this.HomeService.deleteContact(postData)
                  .then((data) => {
                    if(data == 'success'){
                      this.usersList[index].user_data = [];
                      this.getUsers(uid).subscribe((data)=>{
                        if(data.length > 0){
                            data.forEach(uData => {
                              this.usersList[index].user_data.push(uData);
                            })
                        }
                      })
                    }else{
                      this.usersList[index].user_data = [];
                      this.getUsers(uid).subscribe((data)=>{
                        if(data.length > 0){
                            data.forEach(uData => {
                              this.usersList[index].user_data.push(uData);
                            })
                        }
                      })
                    }
                    this.presentToastSuccess('Deleted successfully.');
                    this.loadingProvider.stopLoading();
                  }, (err) =>{

                  });
                  // if(this.data[index].user_data.length > 1){
                  //   this.data[index].user_data.splice((index1), 1);
                  // }else{
                  //   this.data[index].user_data = [];
                  // }
                  
                }
              }
          }
      ]
    });
    alert.present();
  }

  getUsers(contact_uid){
    return this.db.collection<any>( "users_data", ref => ref.where('uid','==',contact_uid ).where('deleted','==',0 )).valueChanges ();
  }

  permanentDeleteContact(event, contact_uid, secondary_contact_uid){

    let alert = this.alertCtrl.create({
      title: 'Confirm Permanently delete contact',
      message: 'Are you sure you want to Permanently delete this contact?',
      buttons: [
          {
              text: 'No',
              handler: () => {
                  console.log('Cancel clicked');
              }
          },
          {
              text: 'Yes',
              handler: () => {
                if(contact_uid !=""){
                  this.loadingProvider.startLoading();
                  var headers = new Headers();
                  headers.append("Accept", 'application/json');
                  headers.append('Content-Type', 'application/json' );
                  const requestOptions = new RequestOptions({ headers: headers });
                  let secondary_contact_uid1 = '';
                  if(secondary_contact_uid != undefined){
                    secondary_contact_uid1 = secondary_contact_uid;
                  }
                  let postData = {
                    'contact_id' : contact_uid,
                    'secondary_contact_uid' : secondary_contact_uid1
                  }
                  var url = this.EnvDataService.EnvData.sendbox_api+"/permanentDeleteContacts";
                  this.http.post(url, postData, requestOptions)
                  .subscribe(data => {
                    if(data['_body'] == 'success'){
                      this.presentToastSuccess('Deleted Permanently successfully.');
                      this.loadingProvider.stopLoading();
                    }else{
                      this.presentToastSuccess('Something went wrong please try again later.');
                      this.loadingProvider.stopLoading();
                    }
                  }, error => {
                    this.presentToast(error.message);      
                  });
                }
              }
          }
      ]
    });
    alert.present();
  }

  changeAssignedBroker(event, contact_uid){
    let changeAssignedBroker = this.modalCtrl.create(ChangeAssignedBrokerPage, {
      "contact_uid": contact_uid
    });

    changeAssignedBroker.present();
  }

  popupAction(event: any, contact_uid: any, SDF_form_document_id: any, contact_type: any){
    let editMenu = this.popoverCtrl.create(EditPopoverPage, {contact_uid: contact_uid, view_contact: 'yes', SDF_form_document_id: SDF_form_document_id, contact_type: contact_type}, {showBackdrop: true, cssClass: 'popOverClass'});
    editMenu.present({
       ev: event // <-- the fix
    });

    editMenu.onDidDismiss(data =>{
      if(data == "" || data == null || data == undefined){}else{
        if(data.type == 'viewcontact'){
          let contact_uid = data.contact_uid;
          this.navCtrl.push(ViewContactPage,{
            contact_uid:contact_uid, 
            SDF_form_document_id: SDF_form_document_id
          });
        }else if(data.type == 'editcontact'){
          let contact_uid = data.contact_uid;
          this.navCtrl.push(StepformPage,{
            edit_contact_uid:contact_uid, 
            SDF_form_document_id: SDF_form_document_id
          });
        }else if(data.type == 'addsecondary'){
          window.localStorage.setItem("contact_uid", data.contact_id_add_real_estate);
          window.localStorage.setItem("creating_second", 'yes');
          this.navCtrl.push(StepformPage);
        }else if(data.type == 'tentativerealestate'){
          window.localStorage.setItem("contact_uid", data.contact_id_add_real_estate);
          window.localStorage.setItem("contact_second_uid", data.second_contact_id);
          this.navCtrl.push(TentativeRealEstateAssetPage,{
            edit_contact_uid:data.contact_id_add_real_estate,
            second_contact_id : data.second_contact_id
          });
          window.localStorage.setItem("generate_new_tentative", '1');
        }else if(data.type == 'changelog'){
          let contact_uid = data.contact_uid;
          this.navCtrl.push(ChangeLogProfilePage,{
            contact_uid:contact_uid
          });
        }
      }
    });
  }

  editContact(event, contact_uid){
    let editMenu = this.popoverCtrl.create(EditPopoverPage, {contact_uid: contact_uid}, {showBackdrop: true, cssClass: 'popOverClass'});
    editMenu.present({
       ev: event
    });
  }

  presentToast(err) {
    const toast = this.toastCtrl.create({
      message: err.message,
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  presentToastSuccess(success) {
    const toast = this.toastCtrl.create({
      message: success,
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  getAllUsersWithPagination (endBefore:number){
    if(this.userRole == 'super_admin'){
      if(this.deleted_access == 1){
        return this.db.collection<any>( "users" , ref => ref.where('created_date','>',0 ).where('roles.contact','==',true ).orderBy('created_date', 'desc').limit(this.limit).startAfter(endBefore)).valueChanges ();
      }else{
        return this.db.collection<any>( "users" , ref => ref.where('created_date','>',0 ).where('roles.contact','==',true ).where('deleted','==',0).orderBy('created_date', 'desc').limit(this.limit).startAfter(endBefore)).valueChanges ();
      }
    }else if(this.userRole == 'broker'){
      return this.db.collection<any>( "users" , ref => ref.where('created_date','>',0 ).where('roles.contact','==',true ).where('reference_broker','==',this.uid ).where('deleted','==',0).orderBy('created_date', 'desc').limit(this.limit).startAfter(endBefore)).valueChanges ();
    }
  }

  getAllUsersWithPaginations (broker_uid, endBefore:number){
    return this.db.collection<any>( "users" , ref => ref.where('created_date','>',0 ).where('roles.contact','==',true ).where('reference_broker','==',broker_uid ).where('deleted','==',0).orderBy('created_date', 'desc').limit(this.limit).startAfter(endBefore)).valueChanges ();
  }

  loadData(event, endBefore) {
    let uid = window.localStorage.getItem("uid");
    let thiss = this;
    setTimeout(() => {
      //let thiss = this;
      if(this.userRole == 'super_admin'){
        if(this.deleted_access == 1){
          this.firestore.collection(`users` , ref => ref.where('created_date','>',0 ).where('roles.contact','==',true ).orderBy('created_date', 'desc').limit(this.limit).startAfter(endBefore)).valueChanges().subscribe((usersList:any) => {
            for(let i = 0; i < usersList.length; i++) { 
              usersList[i].user_data = [];
              usersList[i].total_Record = 0;
              usersList[i].icon = 'ios-arrow-down-outline';
              if(usersList[i].reference_broker == "" || usersList[i].reference_broker == null || usersList[i].reference_broker == undefined){}else{
                var docRef1 = firebase.firestore().collection("users").doc(usersList[i].reference_broker);
                docRef1.get().then(function(doc) {
                  if (doc.exists) {
                    usersList[i].broker_name = doc.data().firstname+' '+doc.data().lastname;
                  } else {
                    console.log("No such document!");
                  }
                }).catch(function(error) {
                  console.log("Error getting document:", error);
                });
                this.usersList.push(usersList[i]);
                //this.loadedUsersList.push(usersList[i]);
              }
              event.complete();
              this.contactTotal = this.usersList.length;
              if(usersList.length == 0){
                event.enable = false;
                this.contactTmore = 0;
              }
            }
          });
        }else{
          this.firestore.collection(`users` , ref => ref.where('created_date','>',0 ).where('roles.contact','==',true ).where('deleted','==',0 ).orderBy('created_date', 'desc').limit(this.limit).startAfter(endBefore)).valueChanges().subscribe((usersList:any) => {
            for(let i = 0; i < usersList.length; i++) { 
              usersList[i].user_data = [];
              usersList[i].total_Record = 0;
              usersList[i].icon = 'ios-arrow-down-outline';
              if(usersList[i].reference_broker == "" || usersList[i].reference_broker == null || usersList[i].reference_broker == undefined){}else{
                var docRef1 = firebase.firestore().collection("users").doc(usersList[i].reference_broker);
                docRef1.get().then(function(doc) {
                  if (doc.exists) {
                    usersList[i].broker_name = doc.data().firstname+' '+doc.data().lastname;
                  } else {
                    console.log("No such document!");
                  }
                }).catch(function(error) {
                  console.log("Error getting document:", error);
                });
              }
              this.usersList.push(usersList[i]);
              //this.loadedUsersList.push(usersList[i]);
            }
            event.complete();
            this.contactTotal = this.usersList.length;
            if(usersList.length == 0){
              event.enable = false;
              this.contactTmore = 0;
            }
          });
        }
      }else if(this.userRole == 'broker'){
        this.firestore.collection(`users` , ref => ref.where('created_date','>',0 ).where('roles.contact','==',true ).where('deleted','==',0 ).where('reference_broker','==',uid ).orderBy('created_date', 'desc').limit(this.limit).startAfter(endBefore)).valueChanges().subscribe(usersList => {
          for(let n = 0; n < usersList.length; n++) { 
            // usersList[n].user_data = [];
            // usersList[n].total_Record = 0;
            // usersList[n].icon = 'ios-arrow-down-outline';
            this.usersList.push(usersList[n]);
          }
          event.complete();
          this.contactTotal = this.usersList.length;
          if(usersList.length == 0){
            event.enable = false;
            this.contactTmore = 0;
          }
        });
      }else if(this.userRole == 'loan_admin'){
        thiss.contactTotal = 0;
        var docRef = firebase.firestore().collection("users").doc(this.uid);
        docRef.get().then(function(doc) {
          if (doc.exists) {
            let user_data = doc.data();
            for(let j = 0; j < user_data.assigned_broker.length; j++){
              thiss.getAllUsersWithPaginations(user_data.assigned_broker[j], thiss.usersList[thiss.usersList.length-1].created_date).subscribe((data)=>{
                for(let i = 0; i < data.length; i++) {  
                  data[i].user_data = [];
                  data[i].total_Record = 0;
                  data[i].icon = 'ios-arrow-down-outline';           
                  if(data[i].reference_broker == "" || data[i].reference_broker == null || data[i].reference_broker == undefined){}else{
                    var docRef1 = firebase.firestore().collection("users").doc(data[i].reference_broker);
                    docRef1.get().then(function(doc) {
                      if (doc.exists) {
                        data[i].broker_name = doc.data().firstname+' '+doc.data().lastname;
                      }
                    }).catch(function(error) {
                      console.log("Error getting document:", error);
                    });
                  }
                }
                thiss.usersList = thiss.usersList.concat(data);
                thiss.contactTotal = thiss.usersList.length;
                event.complete();
                if(data.length == 0){
                  event.enable = false;
                  thiss.contactTmore = 0;
                }
              });
            }
          }
        })
        // event.complete();
        // this.contactTotal = this.usersList.length;
        // event.enable = false;
        // this.contactTmore = 0;
      }
    }, 500);
  }

  getSDFFormByID (contact_uid){
    return this.db.collection<any>( "users_data" , ref => ref.where('uid','==',contact_uid ).where('deleted','<',1)).valueChanges ();
  }

  typeOf(value) {
    return typeof value;
  }
  
  getTotalSDFForms(event, uid, index, total_Records){
    if(this.haveClickedview == true){
      return;
    }
    if(this.haveClickedview == undefined || this.haveClickedview == null){
      this.haveClickedview = true;
    }
    let index1 = index+1;
    let data = [];
    this.haveRecord = [{"count_secondary": null}];
    let total_Record = 0;
    let thiss = this;
    if(total_Records > 0){
      this.usersList[index].icon = 'ios-arrow-down-outline';
      this.usersList[index].total_Record = 0;
      for(let i = 0; i < total_Records; i++){
        this.usersList.splice((index1+i), 1);
      }
      this.haveClickedview = null;
    }else{
      this.usersList[index].icon = 'ios-arrow-up-outline';
      this.getSDFFormByID(uid).subscribe((SDFData)=>{
        if(SDFData.length > 0){
          this.haveRecord = SDFData;
          Object.keys(SDFData).forEach(function(key) {
            SDFData[key]['count_secondary'] = SDFData.length ;
            data.push(SDFData[key]);
            total_Record += 1;
            thiss.usersList[index].total_Record = total_Record;
            var docRef = firebase.firestore().collection("users").doc(SDFData[key].reference_broker);
            docRef.get().then(function(doc) {
              if (doc.exists) {
                let broker_data = doc.data();
                data[key].broker_name = broker_data.firstname+' '+broker_data.lastname;
              }
            });
            thiss.getPrimaryContactBySDFID(SDFData[key].SDF_form_document_id).subscribe((PrimaryContact)=>{
              if(PrimaryContact.length > 0){
                data[key].firstname = PrimaryContact[0].firstname;
                data[key].lastname = PrimaryContact[0].lastname;
                data[key].middlename = PrimaryContact[0].middlename;
              }
            });
          });
        }else{
          total_Record += 1;
          thiss.usersList[index].total_Record = total_Record;
          data = [{'count_secondary': SDFData.length}]
          this.haveRecord = {'count_secondary': SDFData.length};
          this.usersList[index1].user_data = data;
        }
        this.haveClickedview = null;
      });
      this.usersList.splice(index1, 0, {'inner_data':1});
      this.usersList[index1].firstname = this.usersList[index].firstname;
      this.usersList[index1].lastname = this.usersList[index].lastname;
      this.usersList[index1].email = this.usersList[index].email;
      this.usersList[index1].mobile_phone = this.usersList[index].mobile_phone;
      this.usersList[index1].user_data = data;
      this.usersList[index].total_Record = total_Record;
      //data = [];
    }
    //this.data[index1].inner_data = 1;
    //let data1 = {'firstname': 'test', 'inner_data': 1, 'data_count': 2, 'lastname': 'testt', 'email': 'testestteestse@test.tse', 'mobile_phone': '6547821450', 'contact_type': 'Secondary Contact', 'broker_name': 'Kathy Harvey'}
    //this.data[1].user_data = 
    //this.data.splice(3, 0, data1);  
  }

  getPrimaryContactBySDFID (SDF_form_document_id){
    return this.db.collection<any>( "users_data" , ref => ref.where('SDF_form_document_id','==',SDF_form_document_id ).where('contact_type','==','Primary Contact' ).where('deleted','<',1)).valueChanges ();
  }


}


// WEBPACK FOOTER //
// ./src/pages/search/search.ts